import './Login.css';
import React, { Fragment, useContext, useState } from 'react';
import CbmContext from '../../Context/Cbm/cbmContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleExclamation,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';

function Login(props) {
  const cbmContext = useContext(CbmContext);
  const {
    loginUser,
    loginErrorMsg,
    userFriendlyMessage,
    errorReference,
    authLoading,
  } = cbmContext;
  const navigate = useNavigate();
  const location = useLocation();
  const [loginData, setLoginData] = useState({
    userName: '',
    password: '',
  });

  const onHandleChange = (e) => {
    const { name, value } = e.target;
    let tempLoginData = { ...loginData };
    tempLoginData[name] = value;
    setLoginData(tempLoginData);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (loginData.userName?.trim() && loginData.password) {
      let res = await loginUser(loginData.userName, loginData.password);
      // Only navigate to home if login was successful (user returned)
      if (res?.user?.id) {
        const searchParams = new URLSearchParams(location.search);
        const returnTo = searchParams.get('returnTo');
        const safeReturnTo =
          returnTo &&
          returnTo.startsWith('/') &&
          !returnTo.startsWith('//') &&
          returnTo !== '/login' &&
          returnTo !== '/logout'
            ? returnTo
            : '/';
        navigate(safeReturnTo, { replace: true });
      }
      // On failure, stay on login page - error message will display via loginErrorMsg/userFriendlyMessage
    }
  };

  return (
    <Fragment>
      {authLoading ? (
        <FontAwesomeIcon
          className="loading-spinner"
          icon={faSpinner}
          spin
          size="2xl"
        />
      ) : (
        <Fragment>
          {(loginErrorMsg || userFriendlyMessage) && (
            <div className="loginErrMsg">
              <FontAwesomeIcon icon={faCircleExclamation} />
              <p>{userFriendlyMessage || loginErrorMsg}</p>
              {errorReference && (
                <span className="loginErrRef">Ref: {errorReference}</span>
              )}
            </div>
          )}
          <form onSubmit={(e) => onSubmit(e)} className="login-form">
            <div className="container">
              <div className="loginInputs">
                <div className="usernameInput">
                  <label htmlFor="userName">Username</label>
                  <input
                    type="text"
                    name="userName"
                    id="userName"
                    autoComplete="username"
                    value={loginData.userName}
                    onChange={(e) => onHandleChange(e)}
                  />
                </div>
                <div className="passwordInput">
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    name="password"
                    id="password"
                    autoComplete="current-password"
                    value={loginData.password}
                    onChange={(e) => onHandleChange(e)}
                  />
                </div>
              </div>
            </div>
            <button type="submit" className="submit-btn">
              Login
            </button>
          </form>
        </Fragment>
      )}
    </Fragment>
  );
}

Login.propTypes = {};

export default Login;
